<template>
  <div class="modal modal-fullscreen preview fade" :id="modalId" role="dialog" data-backdrop="false">
    <div class="modal-dialog">
      <div class="modal-content">
        <div v-if="modalShown" class="modal-body" style="text-align: center">
          <page-preview v-if="activityType === 'pages'" :id="stepId" :url="previewUrl"></page-preview>
          <step-preview-document
            v-else-if="activityType === 'documents'"
            :campaign-id="campaignId"
            :step-id="stepId"
          ></step-preview-document>
          <step-preview-iframe v-else :url="previewUrl"> </step-preview-iframe>
        </div>
      </div>
    </div>
    <i aria-hidden="true" class="fas fa-times close" data-dismiss="modal"></i>
  </div>
</template>

<script>
import PagePreview from '../../page-preview/PagePreview';
import StepPreviewDocument from './StepPreviewDocument';
import StepPreviewIframe from './StepPreviewIframe';

export default {
  name: 'step-preview-modal',
  components: {PagePreview, StepPreviewDocument, StepPreviewIframe},
  props: {
    activityType: {
      type: String,
      required: true,
    },
    campaignId: {
      type: Number,
      required: true,
    },
    modalId: {
      type: String,
      required: true,
    },
    modalShown: {
      type: Boolean,
      required: true,
    },
    stepId: {
      type: Number,
      required: true,
    },
    vesselId: {
      type: String,
      required: true,
    },
  },
  computed: {
    previewUrl() {
      return (
        '/inventory/campaigns/step/preview/?activity_type=' +
        this.activityType +
        '&sid=' +
        this.stepId +
        '&cid=' +
        this.campaignId +
        '&vid=' +
        this.vesselId
      );
    },
  },
  watch: {
    modalShown: {
      immediate: true,
      handler(shown) {
        $(`#${this.modalId}`).modal(shown ? 'show' : 'hide');
      },
    },
  },
  mounted() {
    $(`#${this.modalId}`).on('hide.bs.modal', () => this.$emit('close-modal'));
  },
};
</script>

<style lang="scss" scoped>
.preview {
  min-height: calc(100vh - var(--admin-bar-height, 0px));
  top: var(--admin-bar-height, 0px);
}

.close {
  position: absolute;
}
</style>
